<!--
 * @Description: 
 * @Date: 2024-03-20 22:18:33
-->
<template>
  <div class="item" v-if="content">
    <div class="value" v-html="content"></div>
  </div>
  <div class="item">
    <div class="title">产品信息</div>
    <div class="value-item" v-for="item in productData" :key="item.id">
      <div class="value">
        <template v-if="item.type === PRODUCT_DRUG">
          <div
            v-if="showOtcContent"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <span>【是否处方药】</span>
            <BaseSelect
              :disabled="item.isOtcFixed == 1"
              style="width: 100px"
              :options="PRESCRIPTION_TYPE"
              v-model="item.isOtc"
            ></BaseSelect>
          </div>
          <p
            v-for="({ label, value }, index) in [
              { label: '批准文号', value: item.approvalNumber, show: true },
              { label: '药品名称', value: item.name, show: true },
              { label: '商品名称', value: item.productName, show: true },
              { label: '药品类型', value: item.medicineType, show: true },
              { label: '剂型', value: item.jixing, show: true }
            ].filter(i => i.show)"
            :key="index"
          >
            {{ `【${label}】：${value || '-'}` }}
          </p>
        </template>
        <template v-if="item.type === PRODUCT_DEVICE">
          <p
            v-for="({ label, value }, index) in [
              { label: '批准文号', value: item.approvalNumber },
              { label: '器械名称', value: item.name },
              { label: '型号规格', value: item.guige }
            ]"
            :key="index"
          >
            {{ `【${label}】：${value || '-'}` }}
          </p>
        </template>
      </div>
    </div>
  </div>
  <div class="item">
    <div class="title">招商要求</div>
    <template v-if="tags">
      <div v-for="tag in tags" :key="tag.id">
        <div class="value">
          <p>{{ tag.name }}：{{ getTagLabel(tag) }}</p>
        </div>
      </div>
    </template>
    <template v-if="tagValues">
      <div v-for="tag in tagValues" :key="tag.label">
        <div class="value">
          <p>{{ tag.label }}：{{ tag.options }}</p>
        </div>
      </div>
    </template>
  </div>
</template>
<script setup lang="tsx">
import { computed, defineProps } from 'vue';
import { Zs } from '../../data-source/types';
import { BaseSelect } from 'xrk-components';
import { PRESCRIPTION_TYPE, PRODUCT_DEVICE, PRODUCT_DRUG } from '../../config';
const props = defineProps<{
  perviewRole: 'c' | 'oss';
  content: Zs['row']['introduce'];
  productData: Zs['row']['productList'];
  tags?: Zs['row']['tags'];
  tagValues?: Zs['row']['tagValues'];
}>();

const showOtcContent = props.perviewRole === 'oss';

const tagsMap = computed(() => {
  return props.tags?.reduce((pre, cur) => {
    cur.childList?.forEach(i => {
      pre[`${cur.id}_${i.id}`] = i;
    });
    return pre;
  }, {} as Record<string, Zs['row']['tags'][number]>);
});

const getTagLabel = (tag: Zs['row']['tags'][number]) => {
  if (tag.isLocation) {
    return (tag.chooseTagValuesStr?.map(i => i.value) || []).join('、');
  }
  return tag.chooseTagValues
    ?.map(i => tagsMap.value?.[`${tag.id}_${i}`]?.name)
    .filter(Boolean)
    .join('、');
};
</script>
<style lang="scss" scoped>
.item + .item {
  margin-top: 28px;
}
.value-item + .value-item {
  margin-top: 24px;
}
.title {
  font-weight: bold;
  font-size: 16px;
  color: #141413;
  line-height: 1;
  margin-bottom: 10px;
}
.value {
  font-size: 14px;
  color: #666666;
  line-height: 1.8;
  ::v-deep {
    img,
    video {
      max-width: 100%;
    }
  }
}
</style>
